export default __webpack_public_path__ + "static/lawyer-month-logo-4e22e065de693d8932f737e53a9ce998.png";